import React, { useContext } from 'react'
import StoreContext from '~/context/StoreContext'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { kebabCase } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../../utils/fontawesome'

const LineItem = props => {
  const { line_item } = props
  const {
    removeLineItem,
    store: { client, checkout },
  } = useContext(StoreContext)

  const variantImage = line_item.variant.image ? (
    <Link to={`/product/${kebabCase(line_item.title)}`}>
      <img
        src={line_item.variant.image.src}
        alt={`${line_item.title} product shot`}
        style={{ height: '60px' }}
      />
    </Link>
  ) : null

  const selectedOptions = line_item.variant.selectedOptions
    ? line_item.variant.selectedOptions.map(
        option => `${option.name}: ${option.value} `
      )
    : null

  const handleRemove = () => {
    removeLineItem(client, checkout.id, line_item.id)
  }

  return (
    <>
      <ItemWrapper>
        <div className='columns is-mobile'>
          <div className='column is-5'>
            <label className='label'>Produkt</label>
          </div>
          <div className='column is-3 has-text-centered'>
            <label className='label'>Menge</label>
          </div>
          <div className='column is-3 has-text-centered'>
            <label className='label'>Preis</label>
          </div>
          <div className='column is-1' />
        </div>

        <div className='columns is-mobile'>
          <div className='column is-5'>

            {variantImage}

            <p>
              {line_item.title}
              {`  `}
              {line_item.variant.title === !'Default Title'
                ? line_item.variant.title
                : ''}
              <br />
              {selectedOptions}
            </p>
          </div>

          <div className='column is-3 has-text-centered'>
            {line_item.quantity}
          </div>

          <div className='column is-3'>
            <p style={{ textAlign: 'center' }} className=''>€{' '}{line_item.quantity * line_item.variant.price}</p>
          </div>

          <div className='column is-1'>
            <RemoveButtonWrapper>
              <FontAwesomeIcon icon='times' className='has-text-primary is-pulled-right' onClick={handleRemove} />
            </RemoveButtonWrapper>
          </div>
        </div>
      </ItemWrapper>
    </>
  )
}

export default LineItem

const ItemWrapper = styled.div`
  margin-top: .5rem;
  border-bottom: 1px solid #bdbdbd;
`

const RemoveButtonWrapper = styled.div`
  &:hover{
    cursor: pointer;
  }
`
